import React from "react"
//import I18n from "i18n-js/index.js.erb"
import clsx from "clsx"
import numeral from "numeral"
import PortalAllFolioTransactions from "../PortalFolios/PortalAllFolioTransactions"

class PortalReservationPresenterTransactionsTab extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'transactions',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="transactions" style={{marginTop: '15px'}}>
        {this.renderFolioSummary()}
        <div className="row">
          <div className="col-md-12">
            <PortalAllFolioTransactions {...this.props} />
          </div>
        </div>
      </div>
    )
  }

  renderFolioSummary() {
    return (
      <div className="row">
        <div className="col-md-12">

          <table className="table table-bordered">
            <thead className="thead">
              <tr className="active">
                <th scope="col">{I18n.t("total_charges")}</th>
                <th scope="col">{I18n.t("total_paid")}</th>
                <th scope="col">{I18n.t('balance')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>${this.formatCurrency(this.props.reservation_segment.total_amount)}</td>
                <td>${this.formatCurrency(this.props.reservation_segment.total_paid_amount)}</td>
                <td>${this.formatCurrency(this.props.reservation_segment.balance_amount)}</td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    )
  }

  formatCurrency(amount) {
    return numeral(amount * this.props.currency.exchange_rate / 100).format(this.props.number_format)
  }
}

export default PortalReservationPresenterTransactionsTab